import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Card from "../components/Card";

import {
  setMCQContext,
  getMCQContext
} from "../utils/mcqContext";

export default function McqSubject() {

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [teachers, setTeachers] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const moduleId =queryParams.get("module_id");
  const gradeId = queryParams.get("grade_id");
  const streamName = queryParams.get("stream_name");

  const flowType = location.state?.type || localStorage.getItem("flow_type") || "mcq";

  /* ================= NAVBAR HIDE / TOP SHOW ONLY ================= */

  useEffect(() => {

    const navbar =
      document.querySelector(
        ".navbar"
      );

    const handleScroll = () => {

      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

      else {

        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";

        navbar.style.opacity =
          "0";

      }

    };

    if (navbar) {

      navbar.style.position =
        "fixed";

      navbar.style.top =
        "15px";

      navbar.style.left =
        "50%";

      navbar.style.width =
        "90%";

      navbar.style.maxWidth =
        "1100px";

      navbar.style.transform =
        "translateX(-50%)";

      navbar.style.zIndex =
        "9999";

      navbar.style.transition =
        "all 0.35s ease";

    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

    };

  }, []);

  /* ================= FETCH TEACHERS ================= */

  useEffect(() => {

    console.log("Current URL:", window.location.href);
    console.log("Grade ID:", gradeId);

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/teacher-data?subject_id=${id}&grade_id=${gradeId}`
    )

      .then(res => res.json())

      .then(data => {

        console.log(
          "Teacher API:",
          data
        );

        setGradeName(
          data.grade_name || ""
        );

        setSubjectName(
          data.subject_name || ""
        );

        setTeachers(
          data.teacher_data || []
        );

      })

      .catch(err => {

        console.error(
          "Teacher API error:",
          err
        );

        setTeachers([]);

      });

  }, [id, gradeId]);

  /* ================= HELPERS ================= */

  const getAvatarText = (
    subject
  ) => {

    if (!subject)
      return "S";

    const clean =
      subject
        .replace(/\//g, " ")
        .replace(/-/g, " ");

    const words =
      clean.split(" ");

    const letters =
      words
        .filter(
          w => w.length > 0
        )
        .slice(0, 2)
        .map(
          w => w[0].toUpperCase()
        )
        .join("");

    return letters;

  };

  /* ================= CLICK HANDLER ================= */

  const handleSelectTeacher = (
    t
  ) => {

    const context =
      getMCQContext() || {};

    setMCQContext({

      ...context,

      subjectId:
        id,

      subjectName:
        subjectName || "Unknown",

      teacherId:
        t.teacher_id,

      teacherName:
        t.name,

      moduleId:
        moduleId,


    });

     if (moduleId) {

       if (flowType === "essay") {

         navigate(
           `/essay/paper/${t.teacher_id}?module_id=${moduleId}`
         );

       } else {

         navigate(
           `/mcq/free/teacher/${t.teacher_id}?module_id=${moduleId}`
         );

       }

     } else {

       navigate(
         `/${flowType}/module/${id}?teacher_id=${t.teacher_id}`,
         {
           state: {
             type: flowType
           }
         }
       );

     }
     };

  /* ================= UI ================= */

  return (

    <div className="mcq-page">

      <h2 className="mcq-title">
        Select Teacher
      </h2>

      <div className="card-grid">

        {teachers.length === 0 && (

          <p
            style={{
              color: "#fff"
            }}
          >
            No teachers available
          </p>

        )}

        {teachers.map(t => (

          <Card

            key={
              t.teacher_id
            }

            title={
              t.name
            }

            subtitle={
              subjectName ||
              gradeName
            }

            avatarText={
              getAvatarText(
                subjectName
              )
            }

            gradient="linear-gradient(135deg,#6366f1,#818cf8)"

            onClick={() =>
              handleSelectTeacher(t)
            }

          />

        ))}

      </div>

    </div>

  );

}


